import React, { useState, useEffect, useRef } from "react";
import "./VerifyTradeStatusCheck.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import CheckIcon from "../../../../assets/images/Dashboard/statusCheck.svg";
import CrossCheckIcon from "../../../../assets/images/Dashboard/statuscross.svg";
import GradiantCrossIcon from "../../../../assets/images/Dashboard/statusCrossGradiant.svg";
import Binance from "../../../../assets/images/binance.svg";
import Bybit from "../../../../assets/images/bybit.svg";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { useNavigate } from "react-router-dom";
import InfoPopup from "../../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import { toastify } from "../../../../helpers/toast/toastify";
import { setCurrentTab } from "../../../../redux/links/linksSlice";
import { useDispatch } from "react-redux";
const leaderTraderItems = [
  {
    id: 1,
    key: "exchangeConnected",
    title: "Exchange connected",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 2,
    key: "communitySetup",
    title: "Community set up",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 3,
    key: "verificationRunning",
    title: "Verification Running",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 4,
    key: "orderYourOwnApp",
    title: "Order your own app",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 5,
    key: "autoShareResults",
    title: "Auto Sharing Results",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 6,
    key: "monthlyReportByEmail",
    title: "Monthly Report by Email",
    icon: CrossCheckIcon,
    active: true,
  },
];

const leaderItems = [
  {
    id: 1,
    key: "exchangeConnected",
    title: "Exchange connected",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 2,
    key: "communitySetup",
    title: "Community set up",
    icon: CrossCheckIcon,
    active: true,
  },
  // {
  //   id: 3,
  //   key: "verificationRunning",
  //   title: "Verification Running",
  //   icon: CrossCheckIcon,
  //   active: false,
  // },
  {
    id: 3,
    key: "orderYourOwnApp",
    title: "Order your own app",
    icon: CrossCheckIcon,
    active: true,
  },

  {
    id: 4,
    key: "autoShareResults",
    title: "Auto Sharing Results",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 5,
    key: "monthlyReportByEmail",
    title: "Monthly Report by Email",
    icon: CrossCheckIcon,
    active: true,
  },
];
const traderItems = [
  {
    id: 1,
    key: "exchangeConnected",
    title: "Exchange connected",
    icon: CrossCheckIcon,
    active: true,
  },
  // { id: 2, key: "communitySetup", title: "Community set up", icon: CrossCheckIcon, active: true },
  {
    id: 3,
    key: "verificationRunning",
    title: "Verification Running",
    icon: CrossCheckIcon,
    active: false,
  },
  // { id: 3, key: "orderYourOwnApp", title: "Order your own app", icon: GradiantCrossIcon },
  {
    id: 4,
    key: "autoShareResults",
    title: "Auto Sharing Results",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 5,
    key: "monthlyReportByEmail",
    title: "Monthly Report by Email",
    icon: CrossCheckIcon,
    active: true,
  },
];

const memberItems = [
  {
    id: 1,
    key: "exchangeConnected",
    title: "Exchange connected",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 2,
    key: "subscribe",
    title: "Subscribe",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 3,
    key: "minimumFunding",
    title: "Minimum Funding",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 4,
    key: "reviewSubmitted",
    title: "Review Submitted",
    subtitle: "Submit Now >",
    icon: CrossCheckIcon,
    active: true,
  },
  {
    id: 5,
    key: "securityOtpSetUp",
    title: "Security (Otp) Set up",
    icon: CheckIcon,
    active: true,
  },
];

const VerifyTradeStatusCheck = ({ user }) => {
  const [items, setItems] = useState([]);
  const [reviewSubmitted, setIsReviewSubmitted] = useState(false);
  const swiperRef = useRef(null);
  const api = useApi();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  

  const isMemberVerified =
    user?.role === "member" &&
    user?.onboarding?.isVerified &&
    user?.onboarding?.connect &&
    user?.onboarding?.payment;

  const isTrader = !user?.leaderCommunity && user?.tradeName;
  useEffect(() => {
    if (!user) return;

    const isLeader = user?.role === "leader";
    const leaderItemsStats =
      isLeader && user?.leaderCommunity
        ? user?.verifiedmyTrade.connect
          ? leaderTraderItems
          : leaderItems
        : user?.tradeName
        ? traderItems
        : leaderItems;
    const baseItems = isLeader ? leaderItemsStats : memberItems;

    let connectedExchange = "";
    if (user?.binanceCredentials?.isConnected) {
      connectedExchange = "Binance";
    } else if (user?.bybitCredentials?.isConnected) {
      connectedExchange = "Bybit";
    }

    const updatedItems = baseItems
      .map((item) => {
        // Shared logic for exchange connection (item.id === 1)
        if (item.key === "exchangeConnected") {
          if (connectedExchange === "Binance") {
            return { ...item, icon: CheckIcon, logo: Binance };
          } else if (connectedExchange === "Bybit") {
            return { ...item, icon: CheckIcon, logo: Bybit };
          } else {
            const { logo, ...rest } = item;
            return rest;
          }
        }

        if (isLeader) {
          if (
            item.key === "communitySetup" &&
            user?.onboarding?.community?.length
          ) {
            const smallestMonthlyFee = Math.min(
              ...(user?.leaderCommunity?.subscription?.map((plan) =>
                parseFloat(plan.monthlyfee)
              ) || [])
            );
            return {
              ...item,
              icon: CheckIcon,
              subtitle: `From $${smallestMonthlyFee}/month`,
            };
          }
          if (item.key === "verificationRunning") {
            if (
              user?.verifiedmyTrade?.payment ||
              user?.verifiedmyTrade?.subscription?.active
            ) {
              return { ...item, icon: CheckIcon, active: true };
            } else if (user?.tradeName) {
              return { ...item, active: true };
            }
          }
          if (item.key === "orderYourOwnApp" && user?.appOrder?.order) {
            return { ...item, icon: CheckIcon };
          }
          if(item.key==="orderYourOwnApp"&&!(user?.appOrder?.order)){
            return { ...item,subtitle:<p
                                    // style={{cursor:"pointer",color:"red",fontWeight:"700"}}
                                    style={{cursor:"pointer"}}
                                    className={"text_GM"}
                                    onClick={() => {
                                      navigate("/leader/payment", {
                                        state: { tab: "orderYourOwnApp" },
                                      });
                                    }}
                                  >
                                    {"Order it now >"}
                                  </p> };
          }
          if (
            item.key === "autoShareResults" &&
            (Object.keys(user?.leaderCommunity?.socials || [])?.length ||
              Object.values(user?.verifytradesocial).some((value) => value))
          ) {
            return { ...item, icon: CheckIcon,
              // subtitle:"Set it up"
            // <button
            //                         className="text_GM"
            //                         onClick={() => {
            //                           navigate("/leader/newCopyTrade", {
            //                             state: { tab: "autoShare" },
            //                           });
            //                           dispatch(setCurrentTab("autoShare"));
            //                         }}
            //                       >
            //                         Set it up
            //                       </button>
                                   };
          }
           if(item.key==="autoShareResults"&&!(Object.keys(user?.leaderCommunity?.socials || [])?.length ||
              Object.values(user?.verifytradesocial).some((value) => value))){
            return { ...item,
              // subtitle:"Set it up"
            subtitle:<p
                                    // style={{cursor:"pointer",color:"red",fontWeight:"700"}}
                                    className="text_GM"
                                    style={{cursor:"pointer"}}
                                    onClick={() => {
                                      navigate("/leader/newCopyTrade", {
                                        state: { tab: "autoShare" },
                                      });
                                      dispatch(setCurrentTab("autoShare"));
                                    }}
                                  >
                                    {"Set it up >"}
                                  </p>
                                   };
          }
          if (
            item.key === "monthlyReportByEmail" &&
            (user?.leaderCommunity
              ? user?.leaderCommunity?.receiveEmailReport
              : user?.getEmailReport)
          ) {
            return { ...item, icon: CheckIcon };
          }

          return item;
        }

        if (!isLeader) {
          const memberCommunity = user?.memberCommunities?.[0]?.community;

          if (
            item.title === "Subscribe" &&
            user?.memberCommunities?.[0]?.subscribed
          ) {
            const planType = user?.memberCommunities?.[0]?.planType;
            const foundSubscription = memberCommunity?.subscription?.find(
              (sub) =>
                sub?._id?.toString() ===
                user?.memberCommunities?.[0]?.subscription
            );

            const subtitle =
              planType === "monthly"
                ? `Tier $${foundSubscription?.monthlyfee}/month`
                : `Tier $${foundSubscription?.yearlyfee}/year`;
            return { ...item, subtitle, icon: CheckIcon };
          }
          if (
            item.title === "Minimum Funding" &&
            user?.memberCommunities?.[0]?.subscribed
          ) {
            const foundSubscription = memberCommunity?.subscription?.find(
              (sub) =>
                sub?._id?.toString() ===
                user?.memberCommunities?.[0]?.subscription
            );

            return {
              ...item,
              subtitle: `Required: $${foundSubscription.minimumFunding}`,
              icon: CheckIcon,
            };
          }
          return item;
        }

        return item;
      })
      .sort((a, b) => {
        const isAChecked = a.icon === CheckIcon ? 1 : 0;
        const isBChecked = b.icon === CheckIcon ? 1 : 0;
        return isBChecked - isAChecked;
      });

    setItems(updatedItems);
  }, [user]);

  const specificUserReview = async () => {
    const response = await api("post", "communityReview/specificUserReview");
    if (response?.status) {
      setIsReviewSubmitted(true);
      setItems((prevItems) =>
        prevItems.map((item) =>
          item.id === 4 ? { ...item, icon: CheckIcon } : item
        )
      );
    }
  };

  useEffect(() => {
    if (user?.role === "member") specificUserReview();
  }, [user]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (swiperRef.current && swiperRef.current.slideTo) {
        swiperRef.current.slideTo(1, 0); // Instant scroll to second slide
      }
    }, 100); // 100ms delay — you can try increasing this if needed

    return () => clearTimeout(timer);
  }, []);
  console.log(items,"these are the updated items please check and confirma  dley me nowno");
  return (
    <div className="VerifyTradeStatusBox">
      <div className="heading">
        <p className="title">Status</p>
      </div>
      <div
        className={`verifyTradeSliderBox statusCheckPadding ${
          !user?.leaderCommunity &&
          user?.tradeName &&
          "verifiedYourTradeSliderBox"
        }`}
      >
        <div className="slider-container">
          <Swiper
            // onSwiper={(swiper) => (swiperRef.current = swiper)}
            spaceBetween={45}
            pagination={{ clickable: true }}
            centeredSlides={false}
            slidesPerView={5}
            loop={false}
            modules={[Pagination]}
            breakpoints={{
              320: { slidesPerView: 2, spaceBetween: 17 },
              480: { slidesPerView: 2, spaceBetween: 17 },
              768: { slidesPerView: 4, spaceBetween: 17 },
              1024: { slidesPerView: 4, spaceBetween: 17 },
              1300: { slidesPerView: 5, spaceBetween: 17 },
              1440: { slidesPerView: 5, spaceBetween: isTrader ? 17 : 45 },
            }}
            className="my-swiper"
          >
            {items
              .filter((item) => item.active)
              .map((item, index) => (
                <SwiperSlide key={item.id} className="slide">
                  <div className="position-relative">
                    <div className="card">
                      {item.icon && (
                        <img
                          className="icon red"
                          src={item.icon}
                          alt="Check Icon"
                        />
                      )}
                      <h3>{item.title}</h3>
                      {item.subtitle && (
                        <p
                          className="subtitle"
                          style={{
                            cursor:
                              item.id === 4 &&
                              user?.role === "member" &&
                              !reviewSubmitted
                                ? "pointer"
                                : "",
                          }}
                          onClick={() => {
                            if (
                              item.id === 4 &&
                              user.role === "member" &&
                              !reviewSubmitted
                            ) {
                              if (isMemberVerified)
                                navigate("/member/submitReview");
                              else
                                toastify(
                                  "Please complete your onboarding steps first",
                                  "error"
                                );
                            }
                          }}
                        >
                          {item.subtitle}{" "}
                          {item.id === 3 && user.role === "member" && (
                            <InfoPopup
                              contentItems={[
                                {
                                  text: "Minimum Funding",
                                  type: "heading",
                                },
                                {
                                  text: "If you don’t have the recommended minimum funds in your trading account your  copy trading will be paused until your trading account is funded accordingly. ",
                                  type: "paragraph",
                                },
                              ]}
                            />
                          )}
                        </p>
                      )}
                      {item.logo && (
                        <img className="logo" style={{marginTop:"0px",marginBottom:"5px"}} src={item.logo} alt="" />
                      )}
                      {/* {item.key==="autoShareResults"&&
                      <button
                                    className="text_GM"
                                    onClick={() => {
                                      navigate("/leader/newCopyTrade", {
                                        state: { tab: "autoShare" },
                                      });
                                      dispatch(setCurrentTab("autoShare"));
                                    }}
                                  >
                                    Set it up
                                  </button>} */}
                    </div>
                    {index !==
                      items.filter((item) => item.active).length - 1 && (
                      <div className="separator" />
                    )}
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default VerifyTradeStatusCheck;
